if (!customElements.get('shipping-search')) {
  customElements.define(
    'shipping-search',
    class ShippingSearch extends HTMLElement {
      constructor() {
        super();

        this.list = this.querySelector('#shipping-search-list');
        this.output = this.querySelector('#shipping-search-output');

        // Initialize Choices.js on the input element
        this.choices = new Choices(this.list, {
          allowHTML: true,
          shouldSort: false,
          position: 'top',
          placeholderValue: 'Search Country...',
          searchPlaceholderValue: 'Search Country...',
        });

        this.addEventListener('addItem', this.search.bind(this));
      }

      search(event) {
        const result = `
            <table>
              <tbody>
                <tr>
                  <th>${window.shippingSearchStrings.country}</th>
                  <td>${event.detail.value}</td>
                </tr>
                <tr>
                  <th>${window.shippingSearchStrings.service}</th>
                  <td>${event.detail.customProperties['service']}</td>
                </tr>
                <tr>
                  <th>${window.shippingSearchStrings.exclusions}</th>
                  <td>${event.detail.customProperties['exclusions']}}</td>
                </tr>
                <tr>
                  <th>${window.shippingSearchStrings.restrictions}</th>
                  <td>${event.detail.customProperties['restrictions']}</td>
                </tr>
                <tr>
                  <th>${window.shippingSearchStrings.cost}</th>
                  <td>${event.detail.customProperties['cost']}</td>
                </tr>
                <tr>
                  <th>${window.shippingSearchStrings.freeOver}</th>
                  <td>${event.detail.customProperties['freeover']}</td>
                </tr>
              </tbody>
            </table>
          `;
        this.output.innerHTML = result;
      }
    }
  );
}
